import { Component, Input } from '@angular/core';
@Component({
    selector: 'app-tabs-main',
    templateUrl: './tabs-main.component.html',
    styleUrls: ['./tabs-main.component.scss'],
    standalone: false
})
export class TabsMainComponent {

  @Input() selectedIndex: number;
  @Input() disabled: boolean = false;

  public select(tabIndex: number): void {
    this.selectedIndex = tabIndex;
  }
}
